import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';

import { SCORING_GUIDE } from 'legacy-src/constants/assessmentResourceTypes';
import { getSignedS3ResourceUrl } from 'chameleon-src/utility/signedUrl';
import downloadResource from './downloadResource';
import Button from 'chameleon/ui-stack/ui/base/button';

const PracticeExamScoringGuideButton = ({
  associatedResources,
  showIcons,
  label,
  role,
  onSendTelemetryEvent,
}) => {
  const resourceUrl = associatedResources[SCORING_GUIDE];
  const resource = resourceUrl && getSignedS3ResourceUrl(resourceUrl);

  const handleDownloadResource = () => {
    downloadResource(resource);
    onSendTelemetryEvent && onSendTelemetryEvent();
  };
  return (
    <Fragment>
      {(showIcons && (
        <AccessibilityWrapper>
          <SingleAction
            role={role}
            onClick={handleDownloadResource}
            tabIndex={0}
            iconName="scoring_guideline"
            iconWidth="16"
            iconHeight="16"
            title="Scoring Guide"
            ariaLabel="Scoring Guide"
          >
            {label}
          </SingleAction>
        </AccessibilityWrapper>
      )) || (
        <Button
          isSecondary
          tabIndex={0}
          data-test-download-pe-scoring-guide
          aria-label="Scoring Guide"
          onClick={handleDownloadResource}
        >
          Scoring Guide
        </Button>
      )}
    </Fragment>
  );
};

PracticeExamScoringGuideButton.propTypes = {
  associatedResources: PropTypes.object,
  label: PropTypes.any,
  className: PropTypes.string,
  role: PropTypes.string,
  onSendTelemetryEvent: PropTypes.func,
};

PracticeExamScoringGuideButton.defaultProps = {
  associatedResources: {},
  label: '',
  className: '',
  role: 'button',
  onSendTelemetryEvent: () => {},
};

export default PracticeExamScoringGuideButton;
